import styled, { css } from "styled-components";

const columnCenter = css`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  margin: auto;
  min-height: 100vh;
  background-color: #f6f6f7;

  p {
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    letter-spacing: 0.5px;
    color: #202020;
  }

  h1,
  h2 {
    font-family: Inter;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px;
    color: #202020;
    letter-spacing: 0.5px;
  }
`;

export const LogoSection = styled.div`
  ${columnCenter}
  justify-content: center;
  height: 20vh;
  flex-shrink: 0;

  img {
    height: auto;
    width: auto;
    max-height: 40%;
  }
`;

export const BalanceSection = styled.div`
  ${columnCenter}
  justify-content: center;
  flex: 1 1 auto;
  gap: 16px;
  text-align: center;
  padding: 0 24px;
  margin-bottom: 40px;

  p:first-child {
    font-family: Inter;
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.5px;
    color: #6b6b6b;
    margin: 0;
    margin-bottom: 8px;
  }

  p:last-child {
    font-family: Inter;
    font-size: 56px;
    font-weight: 700;
    line-height: 1.1;
    color: #202020;
    margin: 0;
  }
`;

export const Footer = styled.footer`
  background-color: #fff;
  ${columnCenter}
  padding: 32px 16px;
  gap: 16px;
  flex-shrink: 0;

  img {
    height: 30px;
    width: auto;
  }

  p {
    color: black;
    font-family: "Inter";
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px; /* 150% */
    letter-spacing: 0.5px;
  }

  .copyToClipboard {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;

    img {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }
  li {
    list-style: none;
  }
`;